import { LoadingOverlay, type LoadingOverlayProps } from "@mantine/core"

export function PageLoader(props: LoadingOverlayProps) {
  return (
    <LoadingOverlay
      visible
      loaderProps={{
        type: "oval",
        color: "gray",
      }}
      overlayProps={{
        blur: 2,
        backgroundOpacity: 0.3,
      }}
      {...props}
    />
  )
}
